import "./card.css";
import html from "./card.html";

function cardComponent(){
    const cardHtml = html;
    return cardHtml;
}

//for demo purposes

const wrapperElement = $('.base-grid');
if ($('.site-wrapper').hasClass('static-home')){
    for(let i = 0; i < 65; i++){
        wrapperElement.append(cardComponent());
        wrapperElement.children('.card:nth-child(2n)').addClass('football');
        wrapperElement.children('.card').eq(0).addClass('livestream');
        wrapperElement.children('.card').eq(8).addClass('live');
        wrapperElement.children('.card').eq(1).addClass('match-hub').find('.status-col').addClass('current');
        wrapperElement.children('.card').eq(2).addClass('match-hub').find('.status-col').addClass('finished');
        wrapperElement.children('.card').eq(7).addClass('dark match-hub').find('.status-col').addClass('future');
        wrapperElement.children('.card').eq(9).addClass('v-gong');
        wrapperElement.children('.card').eq(15).addClass('v-gong');
        wrapperElement.children('.card').eq(22).addClass('accent light');
        wrapperElement.children('.card').eq(24).addClass('accent dark');
    }
}

//if ($('.site-wrapper').hasClass('home-page')){
//wrapperElement.children('.card').eq(0).addClass('size-xl dark');
//wrapperElement.children('.card').eq(1).addClass('size-xl dark');
//wrapperElement.children('.card').eq(2).addClass('size-xl dark');
//wrapperElement.children('.card').eq(3).addClass('accent dark');
//}

